module.exports = __webpack_public_path__ + "img/fdkjwx.a2662523.png";